import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ConfigServerService, CustomHttp } from '../../../../../core';
import { ClienteAnaliseFinanceira } from '../cliente-analise-financeira';

@Injectable({
    providedIn: 'root'
})
export class ClienteAnaliseFinanceiraRevisarHttpService {
    private pathApi: string;

    constructor(configServerService: ConfigServerService,
                private customHttp: CustomHttp) {
        this.pathApi = `${configServerService.getPathApi()}/clienteanalisefinanceira`;
    }

    /** Revisa a análise financeira do cliente */
    revisar(cliente: ClienteAnaliseFinanceira): Observable<ClienteAnaliseFinanceira> {
        return this.customHttp.put<ClienteAnaliseFinanceira>(`${this.pathApi}/${cliente.id}/revisar`, cliente);
    }
}
